'use client'

import { API_URL, apiErrorResponse, apiSuccessResponse, methods } from '@/shared/api/constants'
import { clearSessionCache, getCachedSession } from '@/shared/api/client-api'
import { ApiResponse } from '@/shared/api/types'
import { DeleteHypothesisParams } from '@/shared/api/end-points/hypothesis'

const remove = async (params: DeleteHypothesisParams): Promise<ApiResponse<null>> => {
  const session = await getCachedSession()
  const token = session?.user?.token

  if (!API_URL) {
    throw new Error('Provide API_URL')
  }

  try {
    const endpointPath = `api/v2.4/projects/${params.projectId}/hypotheses/${params.hypothesisId}`.replace(/^\/+/, '')
    const requestUrl = new URL(endpointPath, API_URL.endsWith('/') ? API_URL : `${API_URL}/`).toString()
    console.log('delete hypothesis request', {
      API_URL,
      endpointPath,
      requestUrl,
      params,
    })

    const response = await fetch(requestUrl, {
      method: methods.delete,
      cache: 'no-cache',
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: 'application/json',
        'Cache-Control': 'no-cache',
      },
    })

    if (!response.ok) {
      let errorMessage = response.statusText

      try {
        const contentType = response.headers.get('content-type')
        if (contentType && contentType.includes('application/json')) {
          const errorResponse = await response.json()
          errorMessage = errorResponse.message || response.statusText
        } else {
          errorMessage = `Ошибка сервера: ${response.status} ${response.statusText}`
        }
      } catch {
        errorMessage = `Ошибка сервера: ${response.status} ${response.statusText}`
      }

      if (response.status === 401) {
        clearSessionCache()
      }

      throw new Error(errorMessage)
    }

    const contentType = response.headers.get('content-type')
    if (contentType && contentType.includes('application/json')) {
      const json = await response.json()

      if (json?.status === 'failure') {
        throw new Error(json?.message || 'Не удалось удалить гипотезу')
      }
    }

    return apiSuccessResponse<null>({
      status: response.status,
      result: null,
      response,
      pending: false,
    })
  } catch (error: any) {
    return apiErrorResponse({ error })
  }
}

export default remove
